"use client";
import Link from "next/link";
import { ArrowRight, Briefcase, ShoppingCart, Code2, Wrench, Box } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { partnershipModels as data } from "@/lib/data/partners";

const iconMap: Record<string, React.ComponentType<{ className?: string; style?: React.CSSProperties }>> = { "Referral Partnership": Briefcase, "Reseller Partnership": ShoppingCart, "Technology Integration Partnership": Code2, "Co-Development Partnership": Wrench, "White-Label Partnership": Box };
const accents = ["var(--color-amber)", "var(--color-crimson)", "var(--color-cyan)", "var(--color-purple)", "var(--color-emerald)"];

export function PartnershipModels() {
  return (
    <Section id="partnership-models" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-amber)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 gap-5">
          {data.models.map((m, i) => {
            const Icon = iconMap[m.name] ?? Briefcase;
            const accent = accents[i % accents.length]!;
            return (
              <Reveal key={m.name} delay={i * 80}>
                <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
                  <div className="flex items-center gap-3">
                    <span className="grid place-items-center h-11 w-11 rounded-xl" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                      <Icon className="h-5 w-5" style={{ color: accent }} />
                    </span>
                    <h3 className="text-lg">{m.name}</h3>
                  </div>
                  <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{m.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={500}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
